import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setShowPopup(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setShowPopup(false);

    };

    const handleDecline = () => {
        localStorage.setItem('cookie_consent', 'declined');
        setShowPopup(false);
 
    };

    if (!showPopup) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] animate-fade-in-up">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex-1 text-center md:text-left">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Dbamy o Twoją prywatność</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                        Używamy plików cookies, aby zapewnić poprawne działanie strony oraz (za Twoją zgodą) do celów analitycznych, aby lepiej dopasować ofertę do Twoich potrzeb.
                        Więcej informacji znajdziesz w naszej <Link to="/polityka-prywatnosci" className="text-red-600 font-medium hover:underline">Polityce Prywatności</Link>.
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                    <button
                        onClick={handleDecline}
                        className="px-6 py-2.5 rounded-full border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 hover:border-gray-400 transition-all text-sm whitespace-nowrap"
                    >
                        Tylko niezbędne
                    </button>
                    <button
                        onClick={handleAccept}
                        className="px-6 py-2.5 rounded-full bg-red-600 text-white font-bold hover:bg-red-700 shadow-lg hover:shadow-red-500/30 transition-all text-sm whitespace-nowrap"
                    >
                        Akceptuję wszystkie
                    </button>
                </div>
            </div>
        </div>
    );
}
